import React from 'react';
import '../css/HelpSupport.css';

const HelpSupport = () => {
  return (
    <div className="help-support-container">
      <div className="help-support-content">
        <h1 className="help-support-title">Help & Support</h1>
        <p className="help-support-subtitle">
          Need assistance? We're here to help. Explore common issues or reach out to our support team.
        </p>
        
        <div className="help-support-sections">
          <div className="help-section">
            <h2 className="section-title">Getting Started</h2>
            <p className="section-description">
              Learn how to set up your account, personalize your workspace, and begin managing your brand on Red Fibre.
            </p>
          </div>
          
          <div className="help-section">
            <h2 className="section-title">Creative Tokens & Tools</h2>
            <p className="section-description">
              Understand how to use tokens, automation, and our AI-driven modules for campaigns and branding.
            </p>
          </div>
          
          <div className="help-section">
            <h2 className="section-title">Billing & Plans</h2>
            <p className="section-description">
              Get help with subscription plans, invoices, refunds, and billing queries.
            </p>
          </div>
          
          <div className="help-section">
            <h2 className="section-title">Still need help?</h2>
            <p className="section-description">
              Email us at <a href="mailto:support@redfibre.in" className="support-email">support@redfibre.in</a> or start a support ticket through your dashboard.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpSupport;